import logger from 'Utils/Logger';

export const debugReducer = (state: any = {}, action: any) => {
  logger.debug(action)
  return state
}
